export enum AiChatRatingEnum {
  Bad = 'BAD',
  Good = 'GOOD',
}
